// TZ8-9: общая карта человекочитаемых статусов (задания и споры)
export const TASK_STATUS_LABELS = {
  pending: "Ожидает исполнителя",
  pending_payment: "Требует оплаты",
  open: "Открыто для новых исполнителей",
  discussing: "Обсуждается",
  accepted: "Принято к выполнению",
  in_progress: "Выполняется",
  completed: "Ожидает подтверждения",
  confirmed: "Подтверждено и завершено",
  cancelled: "Отменено",
  escrow: "На рассмотрении (спор)",
  disputed: "Спор открыт",
  revision_requested: "На доработке",
  dispute_resolved_customer: "Спор решён в пользу заказчика",
};

export const DISPUTE_STATUS_LABELS = {
  pending: "В ожидании",
  auto_resolved: "Автоматически решён",
  manual_review: "На рассмотрении",
  awaiting_customer_action: "Ожидает решения заказчика",
  resolved: "Решён",
  archived_on_reopen: "Закрыт при переоткрытии",
};

// TZ8-10: переоткрытое задание (open) входит во вкладку «Активные»
export const ACTIVE_TASK_STATUSES = [
  "pending", "pending_payment", "open", "discussing", "accepted", "in_progress",
  "revision_requested", "disputed", "dispute_resolved_customer",
];

export const taskStatusLabel = (status) => TASK_STATUS_LABELS[status] || "Статус уточняется";
export const disputeStatusLabel = (status) => DISPUTE_STATUS_LABELS[status] || "На рассмотрении";
